var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictogrammesPictoProfil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.25,22.84v3.3l2.39,1.01.3-.31c.13-.14.33-.18.51-.12l4.75,1.68c.2.07.33.25.33.46v10.58c0,.27-.21.49-.48.49-3.29.02-22.5.16-22.5,0,0-.18-.15-11.98,0-11.83.11.1,4.5-1.3,5.71-1.68.19-.06.39,0,.51.15l.27.32,2.11-.68v-3.14c-2.28-.55-4.3-1.79-5.84-3.5-.57.34-1.24.53-1.95.53-2.18,0-3.94-1.79-3.94-4,0-1.84,1.23-3.4,2.9-3.86,0-.18-.01-.36-.01-.54C10.29,5.23,15.44,0,21.79,0s11.51,5.23,11.51,11.69c0,.18,0,.36-.01.54,1.67.47,2.9,2.02,2.9,3.86,0,2.2-1.77,4-3.94,4-.71,0-1.38-.19-1.95-.53-1.35,1.51-3.08,2.65-5.05,3.28Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    y: 30.95,
    width: 8.34,
    height: 5.77,
    rx: 0.8,
    ry: 0.8,
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.66,
    y: 30.95,
    width: 8.34,
    height: 5.77,
    rx: 0.8,
    ry: 0.8,
    transform: "translate(79.66 67.66) rotate(180)",
    fill: "#fff",
    strokeWidth: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogrammesPictoProfil);
export default __webpack_public_path__ + "static/media/PICTOGRAMMES_PICTO_PROFIL.93b08f72bf7ac6149f6ff37092184a1e.svg";
export { ForwardRef as ReactComponent };